import { CurrencyExchangeRate } from "../stores/CurrencyExchangeRateStore";
import SkTechApiClient from "./base/SkTechApiClient";

export default class CurrencyExchangeRateApiClient extends SkTechApiClient {
  public getLatestCurrencyExchangeRate = async (currencyName: string): Promise<CurrencyExchangeRate | null> => {
    return await this.Get(`/api/CurrencyExchangeRate/GetLatestCurrencyExchangeRate/${currencyName}`)
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        console.error("Error fetching tariff plans:", error);
        return [];
      });
  };
}
